import { forwardRef, type SelectHTMLAttributes } from 'react';

/**
 * Local Select shim — @archieai/ui removed the Select molecule in 2.8.x
 * (same casualty class as the PostHogWidget Card shim). Labeled native
 * <select>, prop-compatible with the 2.3.0 surface the dashboard uses
 * (label, value, onChange, size), children = native <option> elements.
 */
export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  label?: string;
  size?: 'sm' | 'md';
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, size = 'md', className, children, ...rest },
  ref,
) {
  const select = (
    <select
      ref={ref}
      className={[
        'w-full rounded-md border border-slate-300 bg-white text-slate-900',
        'focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500',
        size === 'sm' ? 'px-2 py-1 text-sm' : 'px-3 py-2 text-sm',
        className ?? '',
      ].join(' ')}
      {...rest}
    >
      {children}
    </select>
  );
  if (!label) return select;
  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium text-slate-700">{label}</span>
      {select}
    </label>
  );
});
